<div class="tutorial">
    <div gameAsset [gameAssetClass]="'tutorials'" [gameAssetType]="'tutorial'" [gameAssetID]="gameModeIdString"> </div>
</div>